import { render } from "./Performance.vue?vue&type=template&id=bbd3aa90&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"

import "./Performance.vue?vue&type=style&index=0&id=bbd3aa90&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbd3aa90"]])

export default __exports__